module.exports = __webpack_public_path__ + "img/consult_info5.241b36df.png";